module.exports = __webpack_public_path__ + "img/20191123150955022.7bf0bffa.jpg";